import { useState, useEffect, useCallback } from 'react';
import { getFromUrl, serverRequest } from '../api/Api';

const BOT_ENDPOINT = 'dtick-webhook/bot';

const useBotStatus = () => {
  const [isActive, setIsActive] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isToggling, setIsToggling] = useState(false);

  const fetchBotStatus = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getFromUrl(`${BOT_ENDPOINT}/status`);
      if (response?.data && typeof response.data.isActive === 'boolean') {
        setIsActive(response.data.isActive);
      }
    } catch (error) {
      console.error('Failed to fetch bot status:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const toggleBot = useCallback(async () => {
    setIsToggling(true);
    const newStatus = !isActive;
    try {
      const response = await serverRequest({
        endpoint: `${BOT_ENDPOINT}/toggle`,
        body: { isActive: newStatus },
        method: 'PATCH'
      });
      if (response && !response.ok && response instanceof Response) {
        console.error('Failed to toggle bot status');
        return;
      }
      setIsActive(newStatus);
    } catch (error) {
      console.error('Failed to toggle bot:', error);
    } finally {
      setIsToggling(false);
    }
  }, [isActive]);

  useEffect(() => {
    fetchBotStatus();
  }, [fetchBotStatus]);

  return { isActive, isLoading, isToggling, toggleBot };
};

export default useBotStatus;
